module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Quincarnon","short_name":"Quincarnon","start_url":"/","background_color":"#fff","theme_color":"#5e6875","display":"standalone","icon":"static/images/favicon_512.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4008c9b83be09f0d9454453b9ae2e983"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
